<template>
  <div>
    <!-- 提现 -->
    <el-form style="width: 100%" ref="ruleFormRef" :model="ruleForm" label-width="90px" :rules="rules"
      class="demo-ruleForm" :size="formSize" status-icon label-position="right">
      <el-form-item label="提现金额" prop="money">
        <el-input v-model="ruleForm.money" placeholder="请输入提现金额" />
      </el-form-item>
      <el-form-item label="到账银行卡" prop="bankId">
        <el-select v-model="ruleForm.bankId" style="width: 100%" placeholder="请选择" clearable>
          <el-option v-for="(item, index) in options" :key="index"
            :label="item.bankName + '(' + item.bankNo.substr(-6) + ')'" :value="item.id" />
        </el-select>
      </el-form-item>
    </el-form>

    <div class="cardBnt" @click="yesTX">确认提现</div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, defineProps, onMounted } from "vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
const props = defineProps({
  bankList: {
    type: Array,
  },
  handleClose: {
    type: Function,
  },
});
const ruleForm = reactive({
  money: "",
  bankId: "",
});
const options = ref([]) as any;
onMounted(() => {
  options.value = props.bankList;
});
const yesTX = () => {
  Axios("post", "/member/member-out/send", ruleForm, false, function (res) {
    if (res.data.code == 200) {
      ElMessage.success("操作成功");
      props.handleClose(true);
      ruleForm = {
        money: "",
        bankId: "",
      };
    } else {
      ElMessage({
        message: res.data.msg,
        type: "error",
      });
    }
  });
};
</script>

<style scoped>
.cardBnt {
  width: 100%;
  height: 0.53rem;
  line-height: 0.53rem;
  margin-top: 0.2rem;
  background: #C01A26;
  color: #fff;
  text-align: center;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
}
</style>
